<template>
  <v-app>
    <b-announcement
      v-if="store && store.active_subscription === false"
      color="error"
      text-color="black"
    >
      {{ translations.subscriptionInactiveErrorPart1[lang] }}
      <router-link
        :to="`/${lang}/${panelType}/general-settings/billing-dashboard`"
        class="b-signin-link"
        ><span style="color: black; text-decoration: underline">{{
          translations.subscriptionInactiveErrorPart2[lang]
        }}</span></router-link
      >
      {{ translations.subscriptionInactiveErrorPart3[lang] }}
    </b-announcement>
    <b-announcement
      v-if="store && store.cancelled_subscription === true"
      color="warning"
      text-color="black"
    >
      {{ translations.subscriptionCancelledErrorPart1[lang] }}
      {{ getDateString(store.expiration_date_subscription) }}
    </b-announcement>
    <router-view name="header"></router-view>

    <v-main :class="{ 'pa-0': noPadding }">
      <router-view></router-view>
      <Notification />
      <PermissionDialog />
    </v-main>
    <router-view name="footer"></router-view>
  </v-app>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex';
import Notification from '@/components/general/Notification.vue';
import PermissionDialog from '@/components/general/PermissionDialog.vue';
import translations from '@/utils/translations/global';
import API from '@/models/API';
import { subscribeToChannel, unsubscribeFromChannel } from '@/plugins/pusher';

export default {
  name: 'App',

  components: { Notification, PermissionDialog },
  mixins: [translations],

  data: () => ({
    currentPusher: {
      channel: null,
      events: [],
    },
  }),

  computed: {
    ...mapState(['store', 'panelType', 'user']),

    lang() {
      return this.$route.params.lang;
    },
    pusherData() {
      let data = {
        channel: `user-${this.user.user_id}-panel-${this.store.store_id}`,
        events: [
          {
            name: 'export',
            callback: (data) => {
              this.$store.dispatch('exportLinks/handleExportEvent', data);
            },
          },
        ],
      };
      if (!this.user?.user_id || !this.store?.store_id) {
        data.channel = null;
        data.events = [];
        return data;
      }
      if (this.panelType == 'storePanel') {
        data.events.push({
          name: 'new-transaction',
          callback: (data) => {
            this.$store.dispatch('newNotification', data);
          },
        });
        data.events.push({
          name: 'new-redemption',
          callback: (data) => {
            this.$store.commit('newNotification', data);
          },
        });
      }
      return data;
    },

    noPadding() {
      return (
        this.$route.path === `/` ||
        this.$route.path === `/${this.lang}/` ||
        this.$route.path === `/${this.lang}` ||
        this.$route.path === `/${this.lang}/points-pos` ||
        this.$route.path === `/${this.lang}/points-pos/`
      );
    },
  },

  methods: {
    ...mapMutations(['setStoreId', 'setAccessToken', 'setNotification']),
    ...mapActions(['getUser', 'loadAppProvider', 'newNotification']),
    getDateString(val) {
      if (!val) return '-';
      let date = new Date(val);
      return date.toLocaleDateString(this.lang);
    },
    handlePusherSubscriptions() {
      // Unsubscribe previous if exists
      if (this.currentPusher.channel && this.currentPusher.events?.length) {
        unsubscribeFromChannel(this.currentPusher.channel);
      }

      // Subscribe to new channel/events if both are present
      if (
        this.pusherData.channel &&
        this.pusherData.events?.length &&
        this.user?.user_id &&
        this.store?.store_id
      ) {
        this.pusherData.events.forEach(({ name, callback }) => {
          subscribeToChannel(this.pusherData.channel, name, callback);
        });

        // Save current subscription info
        this.currentPusher = {
          channel: this.pusherData.channel,
          events: this.pusherData.events,
        };
      } else {
        // Clear currentPusher if either is missing
        this.currentPusher = {
          channel: null,
          events: null,
          callback: null,
        };
      }
    },
  },

  watch: {
    lang(val) {
      const supportedLangs = ['el', 'en', 'it'];
      let lang = val;
      let path = this.$route.fullPath;

      if (!supportedLangs.includes(lang)) {
        path = path.replace('/' + lang, '/en');
        this.$router.replace(path);
        lang = 'en';
      }
      API.defaults.headers['X-Locale'] = lang;
    },

    errorMessage: {
      handler(val) {
        if (val) {
          this.setNotification({
            show: true,
            type: 'error',
            text: val,
          });
        }
      },
    },

    'pusherData.channel': function (newChannel, oldChannel) {
      if (newChannel && newChannel !== oldChannel) {
        this.handlePusherSubscriptions();
      }
    },
  },

  // async beforeCreate() {
  //     if (Object.keys(caches).length) {
  //         const names = await caches.keys();
  //         await Promise.all(names.map((name) => caches.delete(name)));
  //         window.location.reload();
  //     }
  // },

  mounted() {
    const accessToken = localStorage.getItem('accessToken');
    const storeId = localStorage.getItem('storeId');

    if (accessToken) {
      this.setAccessToken(accessToken);
    }

    if (storeId) {
      this.setStoreId(storeId);
      this.loadAppProvider();
    }

    this.handlePusherSubscriptions();
  },

  beforeDestroy() {
    if (this.currentPusher.channel) {
      unsubscribeFromChannel(this.currentPusher.channel);
    }
  },
};
</script>

<style>
.bb {
  border: 1px solid black !important;
}

.bw {
  border: 1px solid white !important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type='number'] {
  -moz-appearance: textfield;
}

html,
body {
  scroll-behavior: smooth !important;
}

.vuejs-clipper-basic__zoom-area {
  border-radius: 50%;
}
</style>
